/**
 * SaveShipmentButton
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { IntlPropType, createShareCode } from "root/libs/core-libs/src";
import ModalSaveInformation from "one-time-shipment/src/components/Modals/ModalSaveInformation";
import ModalSaveInformationSuccess from "one-time-shipment/src/components/Modals/ModalSaveInformationSuccess";
import { COMMON } from "root/libs/constants/src";
import { DhlButton } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { SaveShipmentWrapper } from "./styled";

const COPY_ID_PREFIX = "SaveShipmentButton";

const SaveShipmentButton = ({
  intl,
  country,
  saveData,
  dataTracking,
  trackEvent,
  isBusiness,
  onSuccessSaveHandler,
  stepperEnabled,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  function onSaveHandler() {
    window.localStorage.setItem(
      `${COMMON.SAVE_SHIPMENT_LOCAL_STORAGE}:${country}`,
      createShareCode(saveData)
    );
    setShowModal(!showModal);
    setShowSuccessModal(!showSuccessModal);
    onSuccessSaveHandler(true);
  }

  return (
    <React.Fragment>
      <SaveShipmentWrapper stepperEnabled={stepperEnabled}>
        <DhlButton
          name="save-shipment-btn"
          dataTestid="save-shipment-btn"
          variant={Variants.outline}
          type="button"
          clickEvent={() => setShowModal(!showModal)}
          dataTracking={dataTracking}
        >
          {intl.formatMessage({ id: `${COPY_ID_PREFIX}.label` })}
        </DhlButton>
      </SaveShipmentWrapper>
      {showModal && (
        <ModalSaveInformation
          trackEvent={trackEvent}
          isOpen={showModal}
          onSave={onSaveHandler}
          isBusiness={isBusiness}
          onClose={() => setShowModal(!showModal)}
        />
      )}
      {showSuccessModal && (
        <ModalSaveInformationSuccess
          isOpen={showSuccessModal}
          onClose={() => setShowSuccessModal(!showSuccessModal)}
        />
      )}
    </React.Fragment>
  );
};

SaveShipmentButton.propTypes = {
  /** Internationalization library */
  intl: IntlPropType.isRequired,
  saveData: PropTypes.object.isRequired,
  dataTracking: PropTypes.string,
  trackEvent: PropTypes.func,
  isBusiness: PropTypes.bool,
  country: PropTypes.string.isRequired,
  onSuccessSaveHandler: PropTypes.func,
  stepperEnabled: PropTypes.bool,
};

export default injectIntl(SaveShipmentButton);
